import { z } from 'zod';
import { lenderDeskingDataShema } from '../model';

export enum RatePresentationType {
  NONE = 'none',
  APR = 'APR',
  ANNUALIZED = 'annualized',
}

export enum ContactType {
  BOTH = 'both',
  DEALER = 'dealer',
  LENDER = 'lender',
}

export enum BrandingType {
  COBRANDED = 'both',
  DEALER = 'dealer',
  LENDER = 'lender',
}

export enum LenderDeskingSections {
  SALE_DETAILS = 'sd',
  CUSTOMER = 'customer',
  STRUCTURE = 'structure',
  CONTINGENCIES = 'contingencies',
  EQUIPMENT = 'equipment',
  DECISION = 'decision',
  PROPOSAL_CONFIGURATION = 'proposalConfiguration',
}

export type LenderDeskingPanelFormValues = z.infer<typeof lenderDeskingDataShema>;
